module.exports = __webpack_public_path__ + "img/project_info_background.ccb529a6.svg";